<template>
    <div class="mx-auto container container--fluid">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-data-table :headers="headers" :items="vendor_list" id="my-table-id" class="elevation-1 mytable" dense
                :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Vendors</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px;"> </span>
                    <v-row>
                        <v-col cols="12" sm="3" md="3">
                            <v-btn rounded color="success" outlined
                                @click="fnExcelReport('my-table-id', 'Vendors','https://eduplusschool.s3.ap-south-1.amazonaws.com/')"><v-icon
                                    color="success">mdi-export</v-icon>Export</v-btn>
                        </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="600px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mt-4 button" v-on="on" small>Add Vendor</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12" class="pb-0">
                                                    <b>Name</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                                                    <v-text-field v-model="editedItem.company_name" persistent-hint
                                                        :rules="[(v) => !!v || 'required']" outlined
                                                        dense></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                                                    <b>Email</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                                                    <v-text-field v-model="editedItem.contact_person_email"
                                                        persistent-hint :rules="[rules.required, rules.email]" outlined
                                                        dense></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                                                    <b>Mobile</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                                                    <v-text-field v-model="editedItem.contact_person_contact"
                                                        type="number" min="0" @keypress="onlyNumbers" persistent-hint
                                                        :rules="true?[
                                                        v => !!v || 'Mobile Number is required',
                                                        v => (v && v.length == 10) || 'Mobile Number Must be 10 digit'
                                                        ]:[v => ((v==null || v=='')?true:(v.length==0||v.length == 10))  || 'Mobile Number Must be 10 digit']"
                                                        outlined dense></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                                                    <b>GST No.</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                                                    <v-text-field v-model="editedItem.gst_no" persistent-hint
                                                        :rules="[(v) => !!v || 'required']" outlined
                                                        dense></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                                                    <b>PAN No.</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                                                    <v-text-field v-model="editedItem.pan_no" persistent-hint
                                                        :rules="[(v) => !!v || 'required']" outlined
                                                        dense></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                                                    <b>Delivery Charges</b><v-icon class="pl-1 pb-2"
                                                        color="error">*</v-icon>
                                                    <v-text-field v-model="editedItem.delivery_charges" persistent-hint
                                                        min="0" type="number"
                                                        :rules="[(v) => v !== null && v !== undefined && v !== '' || 'required']"
                                                        outlined dense @input="updateDeliveryCharges"
                                                        @keypress="onlyNumbers"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="12" md="12" class="pb-0 pt-0"
                                                    v-if="editedIndex != -1">
                                                    <b>Upload Logo</b>
                                                    <v-file-input prepend-icon="mdi-cloud-upload" class="pt-2"
                                                        label="Upload logo" show-size flat rounded outlined dense
                                                        v-model="editedItem.logo_file_edit"></v-file-input>

                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" class="pb-0 pt-0" v-else>
                                                    <b>Upload Logo</b>
                                                    <v-file-input prepend-icon="mdi-cloud-upload" class="pt-2"
                                                        label="Upload logo" show-size flat rounded outlined dense
                                                        v-model="editedItem.logo_file"></v-file-input>



                                                </v-col>



                                                <v-col cols="12" sm="12" md="12" class="pb-0 pt-0"
                                                    v-if="editedIndex != -1">
                                                    <b>Authorized Signature</b>
                                                    <v-file-input prepend-icon="mdi-cloud-upload" class="pt-2"
                                                        label="Upload signature" show-size flat rounded outlined dense
                                                        v-model="editedItem.signature_file_path_edit"></v-file-input>

                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" class="pb-0 pt-0" v-else>
                                                    <b>Authorized Signature</b>
                                                    <v-file-input prepend-icon="mdi-cloud-upload" class="pt-2"
                                                        label="Upload signature" show-size flat rounded outlined dense
                                                        v-model="editedItem.signature_file_path"></v-file-input>


                                                </v-col>


                                                <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                        label="Active"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" color="primary" @click="save" :disabled="!valid"
                                            :loading="loader">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
                <template v-slot:item.delete="{ item }">
                    <div>
                        <v-avatar size="25" class="edit-avatar">
                            <v-icon class=" v-icon-size" color="red" @click="deleteItem(item)">mdi-trash-can</v-icon>
                        </v-avatar>
                    </div>
                </template>
                <template v-slot:[`item.signature_file_path`]="{ item }">
                    <span v-if="item.signature_file_path != 'nullnull'">
                        <a :href="aws_path + item.signature_file_path" target="_blank">
                            <v-icon class="mr-2 v-icon-size" color="primary">mdi-eye</v-icon>
                        </a>
                    </span>
                    <span v-else>--</span>
                </template>
                <template v-slot:[`item.logo_file`]="{ item }">
                    <span v-if="item.logo_file != 'nullnull'">
                        <a :href="aws_path + item.logo_file" target="_blank">
                            <v-icon class="mr-2 v-icon-size" color="primary">mdi-eye</v-icon>
                        </a>
                    </span>
                    <span v-else>--</span>
                </template>

                <template v-slot:item.isactive="{ item }">
                    <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                        @change="toggle(item)"></v-switch>
                </template>
            </v-data-table>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        valid: false,
        overlay: false,
        aws_path: null,
        errorMsg: {
            name: false,
        },
        snackbar_msg: "",
        color: "",
        snackbar: false,
        // extraBreadcrumbItems: [
        //     { text: "Vendor", disabled: true, href: "" },

        // ],
        // breadcrumbClass: "breadcrumb-style2",
        search: "",
        dialog: false,
        loader: false,
        headers: [
            {
                text: "Sr.No",
                align: "left",
                sortable: false,
                value: "sr_no",
            },
            {
                text: "Name",
                align: "left",
                sortable: false,
                value: "company_name",
            },
            {
                text: "Email",
                align: "left",
                sortable: true,
                value: "contact_person_email",
            },
            {
                text: "Mobile",
                align: "left",
                sortable: true,
                value: "contact_person_contact",
            },
            {
                text: "GST No.",
                align: "left",
                sortable: true,
                value: "gst_no",
            },
            {
                text: "PAN No.",
                align: "left",
                sortable: true,
                value: "pan_no",
            },
            {
                text: "Delivery Charges",
                align: "left",
                sortable: true,
                value: "delivery_charges",
            },
            {
                text: "Logo",
                align: "left",
                sortable: true,
                value: "logo_file",
            },
            {
                text: "Signature",
                align: "left",
                sortable: true,
                value: "signature_file_path",
            },
            {
                text: "Status",
                align: "left",
                sortable: true,
                value: "isactive",
            },
            { text: "Actions", value: "action", sortable: false },
            { text: "Delete", value: "delete", sortable: false },
        ],
        editedIndex: -1,
        editedItem: {
            id: "",
            company_name: "",
            contact_person_contact: "",
            contact_person_email: "",
            delivery_charges: "",
            gst_no: "",
            pan_no: "",
            logo_file: null,
            logo_file_edit: null,
            signature_file_path: null,
            signature_file_path_edit: null,
            isactive: true,
        },
        defaultItem: {
            id: "",
            company_name: "",
            contact_person_contact: "",
            contact_person_email: "",
            delivery_charges: null,
            gst_no: "",
            pan_no: "",
            logo_file: null,
            logo_file_edit: null,
            signature_file_path: null,
            signature_file_path_edit: null,
            isactive: true,
        },
        vendor_list: [],
        rules: {
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
        mobile: (value) => {
          const pattern = /[0-9]{10}/;
          return pattern.test(value);
        },
      },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Add New Vendor" : "Edit Vendor";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },
    mounted() {
        this.onLoad();
        this.aws_path = localStorage.getItem("awspath");
    },
    methods: {
        onlyNumbers(event) {
            if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
            }
        },
        fnExcelReport(id, name, aws_path) {
            let tab_text = `<table border='1px'>
            <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>GST No.</th>
            <th>PAN No.</th>
            <th>Delivery Charges</th>
            <th>Logo</th>
            <th>signature</th>
            <th>status</th>
            </tr>`;

                this.vendor_list.forEach((s) => {
                    let isactive = s.isactive ? 'Yes' : 'No';
                    tab_text += `
            <tr>
                <td>${s.sr_no}</td>
                <td>${s.company_name}</td>
                <td>${s.contact_person_email}</td>
                <td>${s.contact_person_contact}</td>
                <td>${s.gst_no}</td>
                <td>${s.pan_no}</td>
                <td>${s.delivery_charges}</td>
                <td><a href="${aws_path + s.logo_file}" target="_blank">${aws_path + s.logo_file}</a></td>
                <td><a href="${aws_path + s.signature_file_path}" target="_blank">${aws_path + s.signature_file_path}</a></td>
                <td>${isactive}</td>
            </tr>`;
                });

                tab_text += '</table>';

                const blob = new Blob([tab_text], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const filename = name + '.xls';

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a); 
                    window.URL.revokeObjectURL(url);
                }
        },
        updateDeliveryCharges(value) {
            // Parse the input value as a float, but preserve 0
            this.editedItem.delivery_charges = value === '' ? null : parseFloat(value);
        },
        editItem(item) {
            this.editedIndex = this.vendor_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },

        save() {
            if (this.editedIndex > -1) {
                if (this.isValidated()) {

                    let formData = new FormData();
                    formData.append("id", this.editedItem.id);
                    formData.append("company_name", this.editedItem.company_name);
                    formData.append("gst_no", this.editedItem.gst_no);
                    formData.append("pan_no", this.editedItem.pan_no);
                    formData.append("contact_person_email", this.editedItem.contact_person_email);
                    formData.append("contact_person_contact", this.editedItem.contact_person_contact);
                    formData.append("delivery_charges", this.editedItem.delivery_charges);
                    formData.append("isactive", this.editedItem.isactive);

                    if (this.editedItem.logo_file_edit) {
                        formData.append("logo_file", this.editedItem.logo_file_edit);
                    }
                    if (this.editedItem.signature_file_path_edit) {
                        formData.append("signature_file_path", this.editedItem.signature_file_path_edit);
                    }
                    axios
                        .post("/EduStore/editVendor", formData)
                        .then((res) => {
                            if (res.data.code == "SUCCESS") {

                                this.showSnackbar("#4caf50", "Vendor is Updated successfully...");
                                this.onLoad();
                                this.loader = false;
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("error", "Something went wrong...");
                            window.console.log(error);
                            this.loader = false;
                        });
                    this.close();

                }
            } else {
                if (this.isValidated()) {
                    this.loader = true;
                    let formData = new FormData();
                    formData.append("company_name", this.editedItem.company_name);
                    formData.append("gst_no", this.editedItem.gst_no);
                    formData.append("pan_no", this.editedItem.pan_no);
                    formData.append("contact_person_email", this.editedItem.contact_person_email);
                    formData.append("contact_person_contact", this.editedItem.contact_person_contact);
                    formData.append("delivery_charges", this.editedItem.delivery_charges);
                    console.log("this.editedItem" + this.editedItem)
                    console.log("this.editedItem.signature_file_path" + this.editedItem.signature_file_path)
                    if (this.editedItem.logo_file) {
                        formData.append("logo_file", this.editedItem.logo_file);
                    }
                    if (this.editedItem.signature_file_path) {
                        formData.append("signature_file_path", this.editedItem.signature_file_path);
                    }
                    axios
                        .post("/EduStore/saveVendor", formData)
                        .then((res) => {
                            if (res.data.code == "SUCCESS") {
                                this.vendor_list.push(this.editedItem);
                                this.showSnackbar("#4caf50", "Vendor is added successfully...");
                                this.onLoad();
                                this.loader = false;
                            } else if (res.data.code == "NA") {
                                this.showSnackbar("#b71c1c", "Vendor is already present!!!");
                                this.loader = false;
                            } else{
                                this.showSnackbar("#b71c1c", "Something went wrong !!!");
                                this.loader = false;
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("error", "Something went wrong...");
                            window.console.log(error);
                            this.loader = false;
                        });
                    this.close();
                }
            }
        }, // end of save()

        onLoad() {
            this.overlay = true;
            axios
                .post("/EduStore/getVendor")
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.vendor_list = res.data.vendor_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },



        deleteItem(item) {

            if (!confirm("Are You Sure You Want To Delete ...?")) return;
            const formData = {
                id: item.id,

            };

            axios
                .post("/EduStore/deleteVendor", formData)
                .then((res) => {
                    if (res.data.status == "YES") {
                        this.showSnackbar("#4caf50", "Vendor Deleted Successfully...");

                        this.onLoad();
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    }
                });
        },
        isValidated() {
            if (this.editedItem.company_name) {
                return true;
            } else {
                if (!this.editedItem.company_name) {
                    this.errorMsg.name = true;
                }

                return false;
            }
        }, // .....end of isValidated()

        toggle(item) {
            const data = {
                section_id: item.id,
                toggle: item.isactive,
            };
            this.overlay = true;
            axios
                .post("/EduStore/toggleVendor", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.code == "SUCCESS") {
                        this.showSnackbar("#4caf50", "Vendor Status Changed Successfully !");
                    } else if (res.data.code == "NA") {
                        this.showSnackbar("#4caf50", "Something went wrong...");
                    }
                })
                .catch((error) => {
                    this.overlay = false;
                    this.showSnackbar("#4caf50", "Something went wrong");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>
